module.exports = new __parcel__URL__("back-to-the-future.7e05c591.jpg").toString();